import React from 'react';

import Context from './Context';

import PageTitleNew from '../../ui/PageTitleNew';
import Table from './Table';

export default function Index() {
  return (
    <Context>
      <div className="wrapper_assestment invite_wrapper">
        <PageTitleNew title="Affiliates" />

        <div className="ibox-content mt20">
          <Table />
        </div>
      </div>
    </Context>

  );
}
